import { omit } from 'ramda';
import { QueryParameters } from '@moda/portal-stanchions';

const KEY_MAP: { [key: string]: string } = {
  'availability[]': 'availability',
  'categories[]': 'category',
  'colors[]': 'colors',
  'sale_tags[]': 'saletags',
  'designers[]': 'designers',
  gender: 'vertical',
  'price[][max]': 'pricemax',
  'price[][min]': 'pricemin',
  'shop_attributes[]': 'attributes',
  'sizes[]': 'sizes',
  'subcategories[]': 'subcategory'
};

const AVAILABILITIES: { [key: string]: string } = {
  1: 'available-now',
  3: 'preorder',
  5: 'trunkshow'
};

const VALUE_MAP: { [key: string]: (value: string) => string } = {
  availability: value => AVAILABILITIES[value],
  colors: value => value.replace(/\//g, '-'),
  sizes: value => value.replace(/[:\s]+/g, '-').toLowerCase()
};

export const transformLegacyPLPQueryParams = (params: QueryParameters) =>
  Object.keys(params).reduce((result, key) => {
    if (!KEY_MAP[key]) return result;
    const value = params[key];
    const newKey = KEY_MAP[key];
    const newValue = VALUE_MAP[newKey]
      ? Array.isArray(value)
        ? value.map(VALUE_MAP[newKey])
        : VALUE_MAP[newKey](value)
      : value;

    return {
      ...result,
      [newKey]: newValue
    };
  }, omit(Object.keys(KEY_MAP), params));
